(function($) {

  $(document).ready(function() {

    //Animate on Scroll
    AOS.init();

  });

})(jQuery);
